module.exports = __webpack_public_path__ + "img/monetization-hero.999cd774.svg";